import { useEffect, useState } from "react";
import { BASEURL } from "../../constants";
import axios from "axios";
import AdminCourseCard from "../Global/CourseCard/AdminCourseCard";
import { useNavigate } from "react-router-dom";

const AdminVerifyCourses = () => {
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {


        const fetchCourses = async () => {
            try {
                const response = await axios.get(`${BASEURL}/api/fetch-admin-verfiy-courses`);

                console.log("1")
                setCourses(response.data.result || []);
                console.log("Courses", response.data)
                setIsLoading(false);
            } catch (error) {
                // console.error("Error fetching courses:", error);
                // setError(error.message);
                setIsLoading(false);
            }
        };

        fetchCourses();
    }, [])

    function cardCLickHandler(id){
        navigate(`/admin-view/${id}`)
    }

    return (
        <div className="w-full h-full">
            <h1 className="p-6 text-xl font-semibold">Verify Courses</h1>
            <div className="px-6 flex gap-6 flex-wrap">
            {
                courses.map((course) => {
                    return <AdminCourseCard course={course} courseId={course.id} onClickHandler={cardCLickHandler} />
                })
            }
            </div>
        </div>
    );
}

export default AdminVerifyCourses;